export default [
  {
    header: 'Pages',
    icon: 'FileIcon',
    children: [
      {
        title: 'الرئيسية',
        route: 'home',
        icon: 'HomeIcon',
      },
      {
        title: 'Second Page',
        route: 'second-page',
        icon: 'FileIcon',
      },
    ],
  },
]
